{
  "title": "Spirit Of Death",
  "source": "The Book of Many Things",
  "levelAndSchool": "4th-level necromancy",
  "level": 4,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a gilded playing card worth at least 400 gp and depicting an avatar of death)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You call forth a spirit that embodies death. The spirit manifests in an unoccupied space you can see within range and uses the reaper spirit stat block. The spirit disappears when it is reduced to 0 hit points or when the spell ends.",
    "The spirit is an ally to you and your companions. In combat, the spirit shares your initiative count and takes its turn immediately after yours. It obeys your verbal commands (no action required by you). If you don’t issue the spirit any commands, it takes the Dodge action and uses its movement to avoid danger.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, use the higher level wherever the spell’s level appears in the reaper spirit stat block.",
    "Reaper Spirit",
    "Medium Undead, Neutral",
    "Armor Class: 11 + the level of the spell (natural armor)",
    "Hit Points: 40 + 10 for each level of the spell above 4th",
    "Speed: 30 ft., fly 30 ft. (hover)",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "16 (+3)",
    "16 (+3)",
    "16 (+3)",
    "16 (+3)",
    "16 (+3)",
    "16 (+3)",
    "Damage Immunities: necrotic, poison",
    "Condition Immunities: charmed, exhaustion, frightened, paralyzed, poisoned",
    "Senses: darkvision 60 ft., passive Perception 13",
    "Languages: understands the languages you speak",
    "Challenge: —",
    "Proficiency Bonus: equals your bonus",
    "Incorporeal Movement. The reaper can move through other creatures and objects as if they were difficult terrain. If it ends its turn inside an object, it is shunted to the nearest unoccupied space and takes 1d10 force damage for every 5 feet traveled.",
    "Actions",
    "Multiattack. The spirit makes a number of Reaping Scythe attacks equal to half the level of the spell (rounded down).",
    "Reaping Scythe. Melee Weapon Attack: your spell attack modifier to hit (with advantage), reach 5 ft., one target. Hit: 1d8 + 3 + the spell’s level necrotic damage.",
    "Bonus Actions",
    "Haunt Creature The spirit targets a creature it can see within 10 feet of itself and begins haunting it. While the target is haunted, you and the spirit sense the direction and distance to the target if it is on the same plane of existence as you. Additionally, if the target starts its turn within 10 feet of the spirit, the target must succeed on a Wisdom saving throw against your spell save DC or have the frightened condition until the start of the target’s next turn. The target remains haunted until it dies, the spirit disappears, or the spirit uses this action again."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
